module.exports = __webpack_public_path__ + "img/holding.8b5ea7e3.png";